import React from 'react';
import { Column, Row } from 'shared';

import { FooterWrapper } from './Footer.styles';
import { FooterBottom } from './footerBottom/FooterBottom';

export const Footer = () => (
  <Row>
    <Column mx={[0, 0, 0, 2]}>
      <FooterWrapper className="footer" px={[1, 2, 2, 5]} noMargin={true}>
        <FooterBottom />
      </FooterWrapper>
    </Column>
  </Row>
);
